import axios from 'axios';
import router from '../router';

const state = {    
  orders: [],
};


const mutations = {
// orders mutations
    SET_ORDERS(state, orders) {
        state.orders = orders;
    }
};

const actions = {
// orders actions
    async fetchOrders({ commit }, { search }) {
        console.log('Fetching orders with search term: ', search);
        const userToken = localStorage.getItem('userToken'); 
        if (!userToken) {
            // Redirect to login page if token is not found
            router.push({ name: 'login' });
            return;
        }

        try {
        const response = await axios.get(`https://api.datafangst.dk/api/rackbeatordre?search=${search}&limit=50`, { headers: { Authorization: `Bearer ${userToken }` }, } );
        console.log('Ordre hentet ', response.data.orders);
        commit('SET_ORDERS', response.data.orders);
        } catch (error) {
        console.error('Error fetching orders:', error);
        throw error; // Rethrow the error to handle it in the component
        }
    }
};

const getters = {
// orders getters
};
    
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};